import { getCookie } from '../../utils/cookies';

// NOTE: Navbar tour is now handled by page tours that merge navbar + page steps
// This hook only provides the cookie checking function for tour merging logic
const useNavbarTour = () => ({
  hasSeenNavbarTour: () => getCookie('navbarTourSeen') === 'true'
});

export default useNavbarTour;
